import styled from 'styled-components'
import { black, grey, lightBlue, lightGray, lightGrayThird } from '../../assets/ui/colors';

import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const QuestionCard = styled.div`
    background: ${lightBlue};
    border: 1px solid ${lightGray};
    box-sizing: border-box;
    border-radius: 6px;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
    & button {
        margin-left: 10px;
        padding: 8px 35px;
        min-width: 100px;
        color: white;
        @media (max-width: 600px) {
            margin-bottom: 3px;
            margin-top: 3px;
        }
    }
    & button.MuiButton-textSecondary {
        background: white;
        color: ${black};
    }
`;

export const CustomPaper = styled(Paper)`
    padding: 2px 4px;
    display: flex;
    align-items: center;
    margin-top: 24px;
    background: ${lightGray};
    box-shadow: none;
    border-radius: 6px;
`;

export const CustomInputBase = styled(InputBase)`
    flex: 1;
    padding: 0 24px;
`;

export const CustomIconButton = styled(IconButton)`
    padding: 10px;
`;

export const Label = styled.div`
    font-size: 12px;
    line-height: 15px;
    color: ${grey};
    margin-top: 2px;
`;

export const OrganisationsList = styled(Paper)`
    padding: 2px 4px;
    display: flex;
    align-items: center;
    margin-top: 1px;
    max-height: 46vh;
    background: ${lightGray};
    box-shadow: none;
    border-radius: 6px;
    & .MuiListItem-button {
        :hover {
            background: ${lightGrayThird};
        }
    }
    & .MuiList-padding {
        width: -webkit-fill-available;
        width: -moz-available;
        width: fill-available;
        max-height: inherit;
        overflow: auto;
    }
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 12px;
`;

export const NextBtn = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    height: 64px;
    width: 145px;
    z-index: 13000;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 100px;
    }
`;
